export const meetingRecordConstants = {
  API_BASE_PATH: 'v1/meeting_records',
};
